import React from "react";
import {useLanguage} from "../../configuration/configuration";
import {Tooltip, TooltipLink} from "../../navigation/buttons/nav-buttons";
import {DashboardAddIcon, fs_bigger, ManageAccountsIcon, WidgetsIcon} from "../../navigation/icons/nav-icons";
import {Popover} from "../../navigation/popover/popover";
import EditGalleryPopover from "../../popover/edit-gallery-popover";

const HomeActionNavigation = ({accessRoles, accessUrls}) => {
    const {isAuthorized, isOwner, isSuperUser} = accessRoles;
    const {editUrl} = accessUrls;
    const Lang = useLanguage();

    // close is a callback from popover component
    const handlePopoverRender = ({close}) => {
        return <div>
            <EditGalleryPopover onClose={close}/>
        </div>
    }

    return <div className='generic-secondary-menu generic-navigation-buttons'>

        <Tooltip title='Neue Bildergalerie erzeugen' className='mr-3'>
            <Popover className='popover-status-container'
                     placement='bottom'
                     render={handlePopoverRender}>
                <button className='btn role-simple-btn mr-1'>
                    <DashboardAddIcon size={fs_bigger} className="clr-white mr-1"/>
                    <span  className='hide-mobile-text clr-white'>Neue Bildergalerie</span>
                </button>
            </Popover>
        </Tooltip>

        {isAuthorized && (isOwner || isSuperUser) &&
            <TooltipLink title={Lang.generic.nav.editUser.tooltip}
                            className='role-simple-btn clr-white mr-3'
                            to={editUrl}>
                <ManageAccountsIcon size={fs_bigger} className="mr-1"/>
                <span className='generic-navigation-text'>{Lang.generic.nav.editUser.text}</span>
            </TooltipLink>}

        {isAuthorized && isSuperUser &&
            <TooltipLink title={Lang.generic.nav.widget.tooltip}
                              className='role-simple-btn clr-white mr-3'
                              to={editUrl}>
                <WidgetsIcon size={fs_bigger} className="mr-1"/>
                <span className='generic-navigation-text'> {Lang.generic.nav.widget.text}</span>
            </TooltipLink>}
    </div>
};

export default HomeActionNavigation;